import { Button } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'

type PropsT = {
  title: string
  onEdit: () => void
  disabled?: boolean
}

const Edit: React.FC<PropsT> = ({ title, onEdit, disabled = false }) => {
  const [css] = useStyletron()

  return (
    <Button
      className={css({
        height: '32px',
        fontSize: '14px',
        marginLeft: '16px',
      })}
      kind="secondary"
      disabled={disabled}
      onClick={onEdit}
    >
      {title}
    </Button>
  )
}

export default Edit
